import { useEffect } from "react";
import Banner from "../components/Academy/Banner";
import Education from "../components/Academy/Education";
import RiskManagement from "../components/Academy/RiskManagement";
import Tabs from "../components/Academy/Tabs";

function Academy() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="bg-[#EFEFEF] relative overflow-hidden">
            <Banner />
            <Education />
            <RiskManagement />
            <Tabs />
        </div>
    );
}

export default Academy;
